<ngb-toast 
    *ngFor="let toast of toastService.toasts" 
    [class]="toast.classname" 
    [autohide]="toast.autohide"
    [delay]="toast.delay" 
    (hide)="toastService.remove(toast)">
    <div class="toast-holder">
        <div class="toast-content">
            <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
                <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
            </ng-template>
            <ng-template #text>
                <div class="toastMessage" [innerHtml]="toast.textOrTpl"></div>
            </ng-template>
        </div>
        <button type="button" class="ct-btn tertiary-btn" (click)="toastService.remove(toast)">OK</button>
    </div>
</ngb-toast>